import React from 'react';
import PropTypes from 'prop-types';
import GoogleMap from 'google-map-react';
import moment from 'moment';
import { MapMarker, Image } from '@components/common';
import constants from '@constants';
import { getCityStateZipString } from '@config/utils';

const LocationCard = ({
	onClickCard,
	data : {
		Id,
		Name,
		StreetAddress1,
		City,
		State,
		Zipcode,
		Latitude,
		Longitude,
		OrganizationName,
		OrganizationPhotoUrl,
		CreatedDate,
		TotalJobCount,
		UpcomingJobCount,
	},
}) => {
	const center = {
		lat : parseFloat(Latitude),
		lng : parseFloat(Longitude),
	};
	const onClick = () => { onClickCard(Id); };

	let address = `${Latitude.toFixed(6)},${Longitude.toFixed(6)}`;

	if (StreetAddress1) address = `${StreetAddress1}, ${getCityStateZipString(City, State, Zipcode)}`;

	return (
		<div className="card">
			<div className="height-90">
				<GoogleMap
					defaultZoom={15}
					center={center}
					bootstrapURLKeys={{ key : constants.GOOGLE_MAP_SETTINGS.key }}
					options={{ ...constants.GOOGLE_MAP_OPTIONS, mapTypeControl : false }}
				>
					<MapMarker
						lat={center.lat}
						lng={center.lng}
					/>
				</GoogleMap>
			</div>
			<div
				className="flex"
				onClick={onClick}
				role="button"
				onKeyPress={null}
				tabIndex={0}
			>
				<div className="flex-center padding-left-10 padding-right-10">
					<i className="rkf rkf-map-pin color-gray-santas" />
				</div>
				<div className="section-address">
					<p className="margin-bottom-0">{ Name }</p>
					<small className="color-dark margin-0">{ address }</small>
				</div>
			</div>
			<div
				className="flex"
				onClick={onClick}
				role="button"
				onKeyPress={null}
				tabIndex={-1}
			>
				<div className="flex-center padding-left-10 padding-right-10">
					<i className="rkf rkf-calendar color-gray-santas" />
				</div>
				<div className="section-created">
					<span>
						Created By
						<i><small className="pull-right font-size-10">{ moment(CreatedDate).format('MMM DD, YYYY') }</small></i>
					</span>
					<div className="flex margin-top-5">
						<Image
							src={OrganizationPhotoUrl}
							fallbackSrc="avatar"
						/>
						<p className="text-primary margin-0">{ OrganizationName }</p>
					</div>
				</div>
			</div>
			<div
				className="footer"
				onClick={onClick}
				role="button"
				onKeyPress={null}
				tabIndex={-2}
			>
				<div className="flex-1 text-center">
					<small>Jobs</small>
					<h5 className="margin-top-0 margin-top-5 color-dark">{ TotalJobCount || 0 }</h5>
				</div>
				<div className="seperator" />
				<div className="flex-1 text-center">
					<small>Upcoming Jobs</small>
					<h5 className="margin-top-0 margin-top-5 color-dark">{ UpcomingJobCount || 0 }</h5>
				</div>
			</div>
		</div>
	);
};

LocationCard.propTypes = {
	onClickCard : PropTypes.func.isRequired,
	data        : PropTypes.object.isRequired,
};

export default LocationCard;
